import queryString from 'query-string';

export function stringifyQuery(params: object) {
  return queryString.stringify(params);
}

export function appendQuery(url: string, params: object) {
  const query = queryString.stringify(params);
  return [url, query].filter(Boolean).join('?');
}

export function parseQuery(search: string) {
  return queryString.parse(search);
}
